// used to verify cache-missed tile requests in our backed
export const TILE_AUTH_HEADER_KEY = 'x-tile-auth-token'
// used to verify caching and coors termination in cf
export const TILE_VERIFY_HEADER_KEY = 'x-cf-tile-verify'

export const PARCEL_TILE_ZOOM_LEVEL = 12
export const POI_TILE_ZOOM_LEVEL = 10
